import React from 'react';
import styled from 'styled-components';
import { withCssSelector } from '../shared/withCssSelector';
import { Icon, IconName } from '../icon';
import { Tooltip } from '../tooltip';

const StyledSpan = styled.span<{ $status: 'neutral' | 'warning' | 'error' }>`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	color: ${props => props.theme.widgetStatus[props.$status].color};
	background-color: ${props =>
		props.$status === 'error'
			? props.theme.widgetStatus.error.background
			: 'transparent'};
	padding: ${props => props.$status === 'error' ? '4px 8px' : '0'};
	border-radius: ${props => props.$status === 'error' ? '4px' : '0'};
	width: fit-content;
	cursor: pointer;
	.icon {
		font-size: 16px;
	}

	.icon-right-warning {
		color: ${props => props.theme.widgetStatus.warning.iconColor};
	}

	.icon-right-error {
		color: ${props => props.theme.widgetStatus.error.iconColor};
	}

`;

export type WidgetStatusProps = {
	StatusText: string;
	Status: 'neutral' | 'warning' | 'error';
	IconLeft?: IconName;
	IconRight?: IconName;
	helpMessage?: string;
	onClick?: () => void;
} & React.ComponentPropsWithoutRef<'span'>;

export const WidgetStatus = withCssSelector(
	React.forwardRef<HTMLSpanElement, WidgetStatusProps>(
		function WidgetStatus({ StatusText, Status, IconLeft, IconRight, helpMessage, onClick, ...props }, ref) {
			return (
				<>
					{helpMessage && (<Tooltip message={helpMessage} placement={'top'}>
						<StyledSpan {...props} ref={ref} $status={Status} onClick={onClick}>
							{IconLeft && (
								<Icon icon={IconLeft} />
							)}
							<span>{StatusText}</span>
							{IconRight && (
								<Icon icon={IconRight} />
							)}
						</StyledSpan>
					</Tooltip>)}
					{!helpMessage && (
						<StyledSpan {...props} ref={ref} $status={Status} onClick={onClick}>
							{IconLeft && (
								<Icon icon={IconLeft} />
							)}
							<span>{StatusText}</span>
							{IconRight && (
								<Icon icon={IconRight} />
							)}
						</StyledSpan>
					)}
				</>
			);
		}
	),
	StyledSpan.toString()
);

